import { base, baseSepolia } from '@ourzora/chains'

const MAINNET_CHAIN_ENV = 'mainnet'
const TESTNET_CHAIN_ENV = 'testnet'
type CHAIN_ENV = typeof MAINNET_CHAIN_ENV | typeof TESTNET_CHAIN_ENV

function isValidChainEnv(chainEnv?: string): chainEnv is CHAIN_ENV {
  return chainEnv === MAINNET_CHAIN_ENV || chainEnv === TESTNET_CHAIN_ENV
}

export const CHAIN_ENV = process.env.NEXT_PUBLIC_CHAIN_ENV as CHAIN_ENV

if (!isValidChainEnv(process.env.NEXT_PUBLIC_CHAIN_ENV)) {
  throw new Error(
    `NEXT_PUBLIC_CHAIN_ENV must be either ${MAINNET_CHAIN_ENV} or ${TESTNET_CHAIN_ENV}, but got ${process.env.NEXT_PUBLIC_CHAIN_ENV}`
  )
}

// Default chain values for Privy Config
export const DEFAULT_CHAIN = CHAIN_ENV === TESTNET_CHAIN_ENV ? baseSepolia : base
export const DEFAULT_CHAIN_ID = DEFAULT_CHAIN.id
export const SUPPORTED_CHAINS = CHAIN_ENV === TESTNET_CHAIN_ENV ? [baseSepolia] : [base]
